import { sortByKey } from '@robovision/rvai-utils'
import path from 'path'
import { Extensions } from '~domain/Extensions'


export function extractBasename (filename: string): string {
  // Get the longest matching "known" extension
  const ext = sortByKey(Object.values(Extensions), 'length', false)
    .find((e) => filename.endsWith(e))
  return path.basename(filename, ext)
}
